export default __webpack_public_path__ + "static/media/missionIcon.ade3121d.png";